// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"26cd4b76","129":"c17f8065","240":"01abdd48","241":"6e95d279","272":"5c6e4460","551":"7a897577","611":"e43b5d22","674":"e410aa6f","902":"5858b4ca"}[chunkId] + ".chunk.js";
};